/* Returns the timestamp (ms) of midnight today in the user's local timezone. */

export function getLocalTodayStart(): number {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now.getTime();
}
